<template>
  <div class="productCertificate-container">
    <!--合格证-->
    <div class="dialog-content">
      <div class="title">{{ $t('bike.name409') }}</div>
      <div class="table-content">
        <el-row class="row-style1">
          <el-col :span="24" class="col-style center">
            <div>{{ $t('bike.name410') }}</div>
            <div class="certificate-img">
              <img :src="certificateDetails.certificateConformityUrl"/>
            </div>
          </el-col>
        </el-row>
        <el-row class="row-style1">
          <el-col :span="6" class="col-style2 margin10"> {{ $t('bike.name278') }} </el-col>
          <el-col :span="18" class="margin10"> {{ certificateDetails.ebikeCode }}</el-col>
        </el-row>
        <!-- <el-row class="row-style1">
          <el-col :span="6" class="col-style2 margin10"> 制造商或商标 </el-col>
          <el-col :span="18" class="margin10"> {{ certificateDetails.manufacturerTrademark }}</el-col>
        </el-row> -->
        <!-- <el-row class="row-style1">
          <el-col :span="6" class="col-style2 margin10"> 生产厂及地址 </el-col>
          <el-col :span="18" class="margin10"> {{ certificateDetails.manufacturingPlantAddress }}</el-col>
        </el-row> -->
        <!-- <el-row class="row-style1">
          <el-col :span="6" class="col-style2 margin10"> 产品型号 </el-col>
          <el-col :span="18" class="margin10"> {{ certificateDetails.ebikeType }}</el-col>
          <el-col :span="6" class="col-style2 margin10"> 驱动方式</el-col>
          <el-col :span="6" class="margin10"> {{ certificateDetails.driveType }}</el-col>
        </el-row> -->
        <!-- <el-row class="row-style1">
          <el-col :span="6" class="col-style2 margin10"> 长/宽/高（mm/mm/mm） </el-col>
          <el-col :span="6" class="col-style2 margin10"> {{ certificateDetails.lengthWidthHeight }}</el-col>
          <el-col :span="6" class="col-style2 margin10"> 前后轮中心距（mm）</el-col>
          <el-col :span="6" class="margin10"> {{ certificateDetails.beforeAfterWheelDistance }}</el-col>
        </el-row> -->
        <!-- <el-row class="row-style1">
          <el-col :span="12" class="col-style2 margin10"> 最高设计车速（km/h） </el-col>
          <el-col :span="12" class="margin10"> {{ certificateDetails.maxSpeed }}</el-col>
        </el-row> -->
        <!-- <el-row class="row-style1">
          <el-col :span="12" class="col-style2 margin10"> 铭牌固定位置 </el-col>
          <el-col :span="12" class="margin10"> {{ certificateDetails.nameplateFixPosition }}</el-col>
        </el-row> -->
        <!-- <el-row class="row-style1">
          <el-col :span="12" class="col-style2 margin10"> 整车编码位置 </el-col>
          <el-col :span="12" class="margin10"> {{ certificateDetails.ebikeCodePosition }}</el-col>
        </el-row> -->
        <!-- <el-row class="row-style1">
          <el-col :span="12" class="col-style2 margin10"> 用于城市物流或商业租赁等经营性活动 </el-col>
          <el-col :span="12" class="margin10"> {{ certificateDetails.materialFlowLeaseManage }}</el-col>
        </el-row> -->
        <!-- <el-row class="row-style1">
          <el-col :span="12" class="col-style2 margin10"> 电机编码 </el-col>
          <el-col :span="12" class="margin10"> {{ certificateDetails.motorCode }}</el-col>
        </el-row> -->
        <!-- <el-row class="row-style1">
          <el-col :span="12" class="col-style2 margin10"> 整车质量 </el-col>
          <el-col :span="12" class="margin10"> {{ certificateDetails.ebikeQuality }}</el-col>
        </el-row> -->
        <el-row class="row-style2">
          <el-col :span="6" class="col-style2 margin10">  {{ $t('bike.name291') }} </el-col>
          <el-col :span="18" class="margin10"> {{ certificateDetails.cccCode }}</el-col>
        </el-row>
        <!-- <el-row class="row-style1">
          <el-col :span="12" class="col-style2 margin10"> 电机功率与额定电压</el-col>
          <el-col :span="12" class="margin10"> {{ certificateDetails.powerVoltage }}</el-col>
        </el-row> -->
        <!-- <el-row class="row-style1">
          <el-col :span="12" class="col-style2 margin10"> 电池类型</el-col>
          <el-col :span="12" class="margin10"> {{ certificateDetails.batteryType }}</el-col>
        </el-row> -->
        <!-- <el-row class="row-style1">
          <el-col :span="12" class="col-style2 margin10"> 车辆制造日期</el-col>
          <el-col :span="12" class="margin10"> {{ certificateDetails.manufactureDate }}</el-col>
        </el-row> -->
        <!-- <el-row class="row-style2">
          <el-col :span="12" class="col-style2 margin10"> 建议使用年限</el-col>
          <el-col :span="12" class="margin10"> {{ certificateDetails.serviceLife }}</el-col>
        </el-row> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  props: {
    certificateDetails: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
<style lang="scss" scoped>
.productCertificate-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  .dialog-title {
    margin-right: 30px;
  }
  .dialog-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    .title {
      font-size: 30px;
      color: #000;
      width: 100%;
      text-align: center;
    }
    .sb-hgzbh {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
    .table-content {
      width: 100%;
      display: flex;
      flex-direction: column;
      margin-top: 10px;
    }
  }

  .certificate-img {
    width: 100%;
    height: 300px;
    img{
      width: auto;
      height: 100%;
    }
  }
  .row-style1 {
    border: 1px solid #dcdddd;
    border-bottom: none;
    width: 100%;
    display: flex;
    align-items: center;
    // background: #f5f5f5;
  }
  .row-style2 {
    border: 1px solid #dcdddd;
    height: 40px;
    width: 100%;
    display: flex;
    align-items: center;
  }
  .col-style {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 10px;
  }
  .col-style1 {
    border-right: 1px solid #dcdddd;
    height: 40px;
    display: flex;
    align-items: center;
  }
  .col-style2 {
    border-right: 1px solid #dcdddd;
    height: 40px;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .margin10 {
    padding-left: 10px;
  }
}
</style>
